import { Close } from '@mui/icons-material';
import { Modal, Box, useMediaQuery, Typography, IconButton, Button, TextField } from '@mui/material'
import { DataGridPro } from '@mui/x-data-grid-pro';
import { useEffect, useMemo, useState } from 'react';
import { API } from '../../lib/api';
import { useThemePreference } from '../../contexts/ThemeContext';


    const columns = [
        {
            field: "manufacturerPartNumber",
            headerName: "Manufacturer Part #",
            flex: 1,
            // renderCell: ({ row: { _id, manufacturerPartNumber } }) => (
            //     <Link
            //         // href={`/products/${_id}`}
            //         underline="none"
            //         sx={{ color: 'rgb(70 128 255)', fontWeight: 500 }} // adjust color here rgb(70 128 255)
            //     >
            //     {manufacturerPartNumber}
            //     </Link>
            // )            
        },
        {
            field: "category",
            headerName: "Catagory",
            flex: 1,
        },
        {
            field: "productCode",
            headerName: "Product Code",
            flex: 1,
        },
        {
            field: "description",
            headerName: "Description",
            flex: 3,
        },
        {
            field: "cost",
            headerName: "Unit Cost",
            flex: 0,
            renderCell: ({ row: { cost } }) => (
                <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    height: '100%',
                }}
                >
                <Typography sx={{ color: '#592e7dff', fontWeight: 500, fontSize: '0.875rem' }}>
                    {cost
                    ? new Intl.NumberFormat("en-US", {
                        style: "currency",
                        currency: "USD",
                        }).format(cost)
                    : '$0.00'}
                </Typography>
                </Box>
            )            
        },     
        {
            field: "price",
            headerName: "Unit Price",
            flex: 0,
            renderCell: ({ row: { price } }) => (
                <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    height: '100%',
                }}
                >
                <Typography sx={{ color: '#2e7d32', fontWeight: 500, fontSize: '0.875rem' }}>
                    {price
                    ? new Intl.NumberFormat("en-US", {
                        style: "currency",
                        currency: "USD",
                        }).format(price)
                    : '$0.00'}
                </Typography>
                </Box>
            )             
        },
        // {
        //     field: "createdBy",
        //     headerName: "Created By",
        //     flex: 1,
        // },
        // {
        //     field: "createdAt",
        //     headerName: "Date Created",
        //     flex: 1,
        //     renderCell: ({ row: { createdAt } }) => {
        //         if (!createdAt) return "";
        //         const date = typeof createdAt === "string" ? new Date(createdAt) : createdAt;
        //         return date.toISOString().split("T")[0]; // 'YYYY-MM-DD'
        //     },               
        // },
        // {
        //     field: "updatedAt",
        //     headerName: "Last Updated",
        //     flex: 1,
        //     renderCell: ({ row: { updatedAt } }) => {
        //         if (!updatedAt) return "";
        //         const date = typeof updatedAt === "string" ? new Date(updatedAt) : updatedAt;
        //         return date.toISOString().split("T")[0]; // 'YYYY-MM-DD'
        //     },               
        // },      
        // {
        //     field: "lastModifiedBy",
        //     headerName: "Last Updated By",
        //     flex: 1,
        // },                         
    ]

const AddItemModal = ({ open, handleClose, title, onAddProducts}) => {
    const { isDarkMode } = useThemePreference();
    const [selectedRows, setSelectedRows] = useState([]);
    const [selectionModel, setSelectionModel] = useState([]);
    const [products,setProducts] = useState([])
    const [mfgQuery, setMfgQuery] = useState("");
    const [descQuery, setDescQuery] = useState("");
    const isMobile = useMediaQuery('(max-width:600px)');
    const isLaptop = useMediaQuery('(max-width:1280px)')

    const handleSelectionChange = (selection) => setSelectedRows(selection) 

    const modalStyle = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: isMobile ? '85vw' : isLaptop ? '80vw' : '80vw',
        maxHeight: 650,
        overflow: "hidden",
        bgcolor: 'background.paper',
        boxShadow: 24,
        borderRadius: 2,
        display: 'flex',
        flexDirection: 'column',
    };
  
    const headerFooterStyle = {
        position: 'sticky',
        zIndex: 1,
        backgroundColor: 'background.paper',
    }; 

    const handleClearAndClose = () => {
        clearFilters()
        setSelectedRows([])
        setSelectionModel([])
        handleClose()
    }

    const handleSubmit = () => {
        const selectedProducts = selectedRows
            .map(id => products.find(p => String(p._id) === String(id)))
            .filter(Boolean);
        
        onAddProducts(selectedProducts); // ✅ pass full objects up
        // close modal, clear selection, etc.
        handleClearAndClose()
    };

    const filteredProducts = useMemo(() => {
        const mq = mfgQuery.trim().toLowerCase();
        const dq = descQuery.trim().toLowerCase();

        if (!mq && !dq) return products;

        return products.filter((p) => {
        const manufacturerPartNumber = (p.manufacturerPartNumber || "").toLowerCase();
        const description = (p.description || "").toLowerCase();

        // AND logic: both filters apply if provided
        const mfgOk = !mq || manufacturerPartNumber.includes(mq);
        const descOk = !dq || description.includes(dq);

        return mfgOk && descOk;
        });
    }, [products, mfgQuery, descQuery]);  
    
    const clearFilters = () => {
        setMfgQuery("");
        setDescQuery("");
    };    


    useEffect(() => {
        async function fetchData() {
            const res = await API.Catalogs.FetchAllPopulated();

            const allProducts = res
            .flatMap(catalog => catalog.products || [])
            .filter((product) => product?.active !== false);

            setProducts(allProducts);
        }

        fetchData();
    }, []);

    return (
        <Modal open={open} onClose={handleClearAndClose}>
            <Box className="hive-add-item-modal" sx={modalStyle}>
                {/* Sticky Header */}
                <Box className="hive-add-item-modal-header" sx={{...headerFooterStyle, top: 0, p: 2, borderBottom: '1px solid #ccc', display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                    <Typography variant="h6">{title}</Typography>
                    <IconButton className="hive-add-item-modal-close" onClick={handleClearAndClose} size="small">
                        <Close />
                    </IconButton>
                </Box>

                {/* Body Goes Here */}
                <Box className="hive-add-item-modal-content" sx={{ overflowY: 'auto', flexGrow: 1, p: 2 }}>
                    <Box className="hive-add-item-modal-filters" sx={{ display: "flex", alignItems: "center", gap: 2, m: 2, flexWrap: "wrap" }}>
                        <TextField
                            label="Manufacturer Part #"
                            variant="outlined"
                            value={mfgQuery}
                            onChange={(e) => setMfgQuery(e.target.value)}
                        />

                        <TextField
                            label="Description"
                            variant="outlined"
                            value={descQuery}
                            onChange={(e) => setDescQuery(e.target.value)}
                        />

                        <Button variant="outlined" onClick={clearFilters} disabled={!mfgQuery && !descQuery}>
                            Clear
                        </Button>
                    </Box>
                    <DataGridPro
                        className="hive-add-item-modal-grid"
                        keepNonExistentRowsSelected
                        checkboxSelection
                        rows={filteredProducts}
                        columns={columns}
                        getRowId={(row) => row._id}
                        rowSelectionModel={selectionModel}
                        onRowSelectionModelChange={(model) => {
                            setSelectionModel(model);
                            handleSelectionChange?.(model);
                        }}
                        pagination
                        initialState={{
                        pagination: { paginationModel: { pageSize: 25, page: 0 } },
                        }}
                        pageSizeOptions={[25, 50, 100]}                        
                    />
                </Box>

                {/* Sticky Footer */}
                <Box className="hive-add-item-modal-footer" sx={{ ...headerFooterStyle, bottom: 0, p: 2, borderTop: '1px solid #ccc', display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
                    <Button type="submit" variant={isDarkMode ? "outlined" : "contained"} color="primary" sx={{ marginTop: "1em" }} onClick={() => handleSubmit(selectedRows)}>
                        Append To Quote
                    </Button>
                </Box>        

            </Box>
        </Modal>        
    )
}

export default AddItemModal
